import { useEffect, useState } from "react";
import FormGroupWrapper from "./FormGroupWrapper";
import { labelUtils } from "../Util";
import Select from "react-select";
import rootReducer from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";

const CustomAllMultiSelect = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  const optionsMulti = fieldEle?.["data-customvalue"] || [];
  const key = databaseKey ? databaseKey : displayLabelKey;

  const allOption = { label: "Select All", value: "*ALL" };
  const enhancedOptions = [allOption, ...optionsMulti];

  const [selectedValues, setSelectedValues] = useState(formState[key] || []);

  useEffect(() => {
    setSelectedValues(formState[key] || []);
  }, [formState, key, optionsMulti]);

  const handleSelectChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "*ALL")) {
      if (selectedValues.length === optionsMulti.length) {
        setSelectedValues([]);
        rootReducer.dispatch(setRendererFormState({ key, value: [] }));
      } else {
        setSelectedValues(optionsMulti.map((option) => option.value));
        rootReducer.dispatch(
          setRendererFormState({
            key,
            value: optionsMulti.map((option) => option.value),
          })
        );
      }
    } else {
      const selected = selectedOptions.map((option) => option.value);
      setSelectedValues(selected);
      rootReducer.dispatch(setRendererFormState({ key, value: selected }));
    }
  };

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <Select
          id={newElfromJSON}
          name={key}
          options={enhancedOptions}
          placeholder={fieldEle?.["display-placeholder"]}
          isMulti
          isDisabled={fieldEle?.["display-disabled"] === 1}
          isRequired={
            showRequired ? fieldEle?.["display-required"] === 1 : false
          }
          value={enhancedOptions.filter((option) =>
            selectedValues.includes(option.value)
          )}
          onChange={handleSelectChange}
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default CustomAllMultiSelect;
